var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xy-pagelet-container",class:_vm.className},[_vm._t("default",function(){return [_c('div',{staticClass:"xy-pagelet-container-placeholder"},[_c('span',[_vm._v(_vm._s(_vm.$t("k_e621cb4b")))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }